import React from 'react';
import styled from 'styled-components';
import Tab from './components/Tab/TabComponent';
import flexbox from 'styles/utils/flexbox';
import { mediaQueries } from 'styles/utils/mediaQueries';

function TabsComponent({ tabs, selected, onClickTab, orientation = 'horizontal' }) {
  return (
    <Root orientation={orientation}>
      <Tabs orientation={orientation}>
        {tabs.map(({ id, label }) => (
          <Tab key={id} id={id} label={label} selected={selected === id} onClick={onClickTab} />
        ))}
      </Tabs>
      <TabContainer orientation={orientation}>
        {tabs.map(({ id, component }) => {
          if (id === selected) {
            return component;
          }

          return null;
        })}
      </TabContainer>
    </Root>
  );
}

export default TabsComponent;

const Root = styled.div`
  ${({ orientation }) =>
    flexbox({
      flexDirection: orientation === 'horizontal' ? 'column' : 'row',
    })}

  margin: 0 auto;
  margin-bottom: 24px;

  ${mediaQueries.fromAndBelow.tablet`
    flex-direction: column;
  `}
`;

const Tabs = styled.div`
  ${({ orientation }) =>
    flexbox({
      flexDirection: orientation === 'horizontal' ? 'row' : 'column',
    })}

  width: ${({ orientation }) => (orientation === 'horizontal' ? '100%' : '20%')};

  ${mediaQueries.fromAndBelow.tablet`
    flex-direction: row;
    width: 100%;
  `}
`;

const TabContainer = styled.div`
  width: ${({ orientation }) => (orientation === 'horizontal' ? '100%' : '80%')};
  padding: 23px 32px 15px;
  background: ${({ theme }) => theme.colors.background.light};
  border: 1px solid ${({ theme }) => theme.colors.primary.default};
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

  ${mediaQueries.fromAndBelow.tablet`
    width: 100%;

    border-top-right-radius: 0;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  `}
`;
